import actionTypes from './actions/actionTypes'

const {
  REQUEST_CHANGEPLAN,
  RECEIVE_CHANGEPLAN,
  REQUEST_STORAGEINFO,
  RECEIVE_STORAGEINFO,
  ERROR_CHANGEPLAN
} = actionTypes

const mangePlansReducer = (state = {
  isUpdatingPlan: false,
  isFetchingStorageInfo: false,
  storageInfo: '',
  planerror: false
}, action) => {
  switch (action.type) {
    case REQUEST_CHANGEPLAN:
      return Object.assign({}, state, {
        isUpdatingPlan: true,
        planerror: false
      })
    case RECEIVE_CHANGEPLAN:
      return Object.assign({}, state, {
        isUpdatingPlan: false,
        planerror: false
      })
    case ERROR_CHANGEPLAN:
      return Object.assign({}, state, {
        isUpdatingPlan: false,
        upgrade: false,
        planerror: true
      })
    case REQUEST_STORAGEINFO:
      return Object.assign({}, state, {
        isFetchingStorageInfo: true
      })
    case RECEIVE_STORAGEINFO:
      return Object.assign({}, state, {
        isFetchingStorageInfo: false,
        storageInfo: action.storageInfo
      })
    default:
      return state
  }
}

export default mangePlansReducer



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/reducer.js